module.exports = __webpack_public_path__ + "static/media/ebay.b267faad.png";